export enum EmploymentStatus {
  FullTime = 0,
  PartTime = 1,
  Owner = 2,
  Other= 3  ,
  Contractor = 4,
}
